import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/desktop/leaves_524x558.webp")